import http from '@/utils/http';
const base_path = '/v2/tool/wechatChannelAccount';

/**
 * 获取微信视频号列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getWechatChannelAccountListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
